import { ObservableArray, View } from "binder"
import { InquiryListViewModel, providers } from "./inquiryList-viewModel"

export class InquiryListView extends View<InquiryListViewModel>{
    GetViewUniqueId(): string {
        return "V-920F485D-33F8-4A87-9A63-7996DCD1B2C7"
    }
    loadHtml(): string {
        let element = require('./inquiryList.html').default;
        let style = require('./inquiryList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<providers>) { this._items = v; } public get items(): ObservableArray<providers> { return this._items;} private _items: ObservableArray<providers>;

}
